import { render, staticRenderFns } from "./InstrumentTags.vue?vue&type=template&id=0f34ea25"
import script from "./InstrumentTags.vue?vue&type=script&lang=js"
export * from "./InstrumentTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports